import { render } from "./DashOption.vue?vue&type=template&id=75718a18&scoped=true"
import script from "./DashOption.vue?vue&type=script&lang=js"
export * from "./DashOption.vue?vue&type=script&lang=js"

import "./DashOption.vue?vue&type=style&index=0&id=75718a18&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75718a18"]])

export default __exports__